import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import GiftNotifier from '../Gifts/GiftNotifier'
import CartLocation from '../../containers/CartLocationContainer'
import ToolbarOption from '@/checkout-instore-legacy/components/Commons/Elements/ToolbarOption'
import { getInstoreConfig } from '../../../utils/configUtils'
import { ToolbarOptionNote } from './ToolbarOptionNote'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'

export default function Toolbar({
  buttonsEnabled,
  hasGifts,
  noteValue,
  salesAssociateCode,
  hasCoupon,
  hasItems,
  selectableGifts,
  onShareClick,
  onGiftClick,
  onCouponClick,
  onSalesAssociateCodeClick,
  onNoteClick,
  onTransferClick,
}) {
  const { transferEnabled: isTransferEnabled, socialShare } = getInstoreConfig()
  const intl = useIntl()

  return (
    <div className="bb b--black-20 bg-base">
      <div className="flex flex-column flex-row-ns justify-between-ns pa5 pv4-ns ph6-ns">
        <div className="flex truncate">
          <CartLocation />
        </div>
        {buttonsEnabled && (
          <div className="flex justify-between justify-start-ns bn-ns bt b--muted-5 pt3 pt0-ns mt3 mt0-ns">
            {hasGifts ? (
              <div className="pl7-ns">
                <GiftNotifier
                  onClick={onGiftClick}
                  selectableGifts={selectableGifts}
                />
              </div>
            ) : (
              ''
            )}

            {!!socialShare && hasItems && (
              <div className="pl7-ns">
                <ToolbarOption
                  id="shareShow"
                  iconType="nc-share-26"
                  onClick={onShareClick}
                >
                  <FormattedMessage id="shareToolbar" />
                </ToolbarOption>
              </div>
            )}

            {onCouponClick && (
              <div className="pl7-ns">
                <ToolbarOption
                  id="couponShow"
                  iconType="nc-ticket"
                  isEmpty={!hasCoupon}
                  onClick={onCouponClick}
                >
                  <FormattedMessage id="cartCoupon" />
                </ToolbarOption>
              </div>
            )}
            <div className="pl7-ns">
              <ToolbarOptionNote
                noteValue={salesAssociateCode}
                onNoteClick={onSalesAssociateCodeClick}
                label={intl.formatMessage({ id: 'cartVendor' })}
              />
            </div>
            <div className="pl7-ns">
              <ToolbarOptionNote
                noteValue={noteValue}
                isOrderNote
                onNoteClick={onNoteClick}
                label={intl.formatMessage({ id: 'cartObservation' })}
              />
            </div>
            {isTransferEnabled && onTransferClick && (
              <div className="pl7-ns">
                <ToolbarOption
                  id="transferShow"
                  iconType="nc-transfer"
                  onClick={onTransferClick}
                >
                  <FormattedMessage id="cartTransfer" />
                </ToolbarOption>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

Toolbar.defaultProps = {
  buttonsEnabled: true,
}

Toolbar.propTypes = {
  buttonsEnabled: PropTypes.bool,
  hasGifts: PropTypes.any,
  salesAssociateCode: PropTypes.any,
  noteValue: PropTypes.any,
  hasCoupon: PropTypes.any,
  hasItems: PropTypes.bool,
  selectableGifts: PropTypes.array,
  onShareClick: PropTypes.func,
  onGiftClick: PropTypes.func,
  onCouponClick: PropTypes.func,
  onNoteClick: PropTypes.func,
  onSalesAssociateCodeClick: PropTypes.func,
  onTransferClick: PropTypes.func,
}
